class ChatSelector extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.whatsappButton = this.querySelector('.chat-selector__whatsapp-button');
    this.closeButton = this.querySelector('.chat-selector__close-button');
    this.mainButton = this.querySelector('.chat-selector__main-button');
    this.buttonWrapper = this.querySelector('.chat-selector__buttons');
    this.closeButton.addEventListener('click', this.closeButtons.bind(this));
    this.mainButton.addEventListener('click', this.mainButtonFunction.bind(this));
    window.zESettings = {    webWidget: {      offset: {        horizontal: '100px',        vertical: '150px'      }    }  };
  }

  closeButtons() {
    this.buttonWrapper.removeAttribute('open');
    zE('messenger', 'close');
  }

  openButtons() {
    this.buttonWrapper.setAttribute('open', '');
  }


  mainButtonFunction() {
    if (this.buttonWrapper.hasAttribute('open')) {
      zE('messenger', 'open');
    } else {
      this.openButtons();
    }
  }
}

customElements.define('chat-selector', ChatSelector);
